interface DocumentProps {
    documents: Array<{
        name: string;
        data: string;
        url: string | undefined;
    }>;
}

export function documentReferences(props: DocumentProps) {
    const documentUrl = `${process.env.REACT_APP_CHAT_API_URL}/document`;

    return (
        <div className="document-references">
            <h2>Document References</h2>
            <ul className="list-disc pl-5">
                {props.documents.map((doc, index) => (
                    <li key={index}>
                        <a
                            href={doc.url ? `${documentUrl}/${doc.url.replace(/^document:\/\//, '')}` : "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-chat-link underline hover:text-chat-link/80"
                            onClick={(e) => {
                                if (!doc.url) {
                                    e.preventDefault();
                                    alert("No URL available for this document.");
                                }
                            }}
                        >
                            {doc.data}
                        </a>
                    </li>
                ))}
            </ul>
            {props.documents.length === 0 && <p>No document references available.</p>}
        </div>
    );
}